import React, { useEffect, useState } from "react";
import Table, { ActionsPill } from '../../components/Table'  // new
import { getReportsRequested, getAdminReportRequested } from "../../actions/reportAction";
import { DocumentDownloadIcon, DocumentIcon, DocumentReportIcon, DownloadIcon } from "@heroicons/react/outline";
import { UsersIcon, UserGroupIcon, CheckCircleIcon, TrendingUpIcon } from "@heroicons/react/solid";
// import Modal from '../../components/Modal';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Logo } from '../../utils/images';
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

const AdminReport = ({
    user,
    report,
    adminReportGetRequested,
    getAdminReportRequested: getReport
}) => {
    const [errors, setErrors] = useState(null);
    const [formData, setFormData] = React.useState({});
    const [genPDF, setGenPDF] = React.useState(false);
    const [formIsValid, setFormIsValid] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState('custom');
    const base64Img = Logo();
    let totalPagesExp = "{total_pages_count_string}";

    // Date range calculation helpers
    const getCurrentWeekRange = () => {
        const startOfWeek = moment().startOf('week');
        const endOfWeek = moment().endOf('week');
        return {
            startDate: startOfWeek.format('YYYY-MM-DD'),
            endDate: endOfWeek.format('YYYY-MM-DD')
        };
    };

    const getCurrentMonthRange = () => {
        const startOfMonth = moment().startOf('month');
        const endOfMonth = moment().endOf('month');
        return {
            startDate: startOfMonth.format('YYYY-MM-DD'),
            endDate: endOfMonth.format('YYYY-MM-DD')
        };
    };

    const getOneWeekAgoRange = () => {
        const endDate = moment().subtract(1, 'week').endOf('week');
        const startDate = moment().subtract(1, 'week').startOf('week');
        return {
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD')
        };
    };

    const getOneMonthAgoRange = () => {
        const endDate = moment().subtract(1, 'month').endOf('month');
        const startDate = moment().subtract(1, 'month').startOf('month');
        return {
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD')
        };
    };

    const getTwoMonthsAgoRange = () => {
        const endDate = moment().subtract(2, 'month').endOf('month');
        const startDate = moment().subtract(2, 'month').startOf('month');
        return {
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD')
        };
    };

    // Calculate summary statistics
    const getReportStats = () => {
        if (!report || report.length === 0) {
            return {
                totalCells: 0,
                totalMembers: 0,
                totalPresent: 0,
                averageAttendance: 0
            };
        }

        const totalCells = report.length;
        const totalMembers = report.reduce((sum, row) => sum + (parseInt(row.cellTotal, 10) || 0), 0);
        const totalPresent = report.reduce((sum, row) => sum + (parseInt(row.totalAttendance, 10) || 0), 0);
        const averageAttendance = totalMembers > 0 ? Math.round((totalPresent / totalMembers) * 100) : 0;

        return {
            totalCells,
            totalMembers,
            totalPresent,
            averageAttendance
        };
    };
    const columns = React.useMemo(() => [
        {
            Header: "No.",
            accessor: 'id',
            Cell: ({ cell }) => (
                <div className="flex items-center space-x-2">
                    <p>{cell.row.index + 1}</p>
                </div>
            ),
        },
        {
            Header: "Date",
            accessor: 'date',
            Cell: ({ cell }) => (
                <div className="flex items-center space-x-2">
                    <p>{cell.value ? moment(cell.value, 'YYYY-MM-DD').format('MMM DD, YYYY') : '-'}</p>
                </div>
            ),
        },
        {
            Header: "Leader",
            accessor: 'cell.CellLeader.name',
        },
        {
            Header: "Cell Meeting Day",
            accessor: 'cell.meeting_day',
        },
        {
            Header: "Cell Type",
            accessor: "cell.cell_type",
        },
        {
            Header: "Total Regular Members",
            accessor: 'cellTotal',
        },
        {
            Header: "Members Present",
            accessor: 'attendanceTotal',
        },
        {
            Header: "Total Present",
            accessor: 'totalAttendance',
        },
        {
            Header: "Remarks ",
            accessor: 'remarks',
            // accessor: 'status',
            Cell: ({ cell, row }) => (
                <div className="flex items-center space-x-2">
                    {/* <p className="text-xs">No.of guests:
                        {row.original.guestsTotal || 0}</p> */}
                </div>
            ),
            // Cell: ActionsPill,
        },
    ], []);

    React.useEffect(() => {
        const isValid = handleValidation();
        setFormIsValid(isValid);
    }, [formData]);

    useEffect(() => {
        if (genPDF && report && report.length > 0 && formData && columns && totalPagesExp) {
            setGenPDF(false);
            console.log("Generate PDF");
            //Generate PDF
            const doc = new jsPDF("p", "pt");

            // Define table columns and rows
            const tableColumns = columns.map(column => column.Header);
            const tableData = report.map((row, index) => {
                const rowData = [];
                columns.forEach(column => {
                    if (column.accessor === 'cell.CellLeader.name') {
                        rowData.push(row.cell.CellLeader?.name || '');
                    } else if (column.accessor === 'date') {
                        rowData.push(row.date ? moment(row.date, 'YYYY-MM-DD').format('MMM DD, YYYY') : '-')
                    } else if (column.accessor === 'cell.meeting_day') {
                        rowData.push(row.cell?.meeting_day || '')
                    } else if (column.accessor === 'cell.cell_type') {
                        rowData.push(row.cell?.cell_type || '')
                    } else if (column.accessor === 'remarks') {
                        // rowData.push(`No.of guests: ${row.guestsTotal || 0}`)
                    } else if (column.accessor === 'id') {
                        rowData.push(index + 1);
                    } else {
                        rowData.push(row[column.accessor]);
                    }
                });
                return rowData;
            });


            // Auto-generate table
            doc.autoTable({
                head: [tableColumns],
                body: tableData,
                didDrawPage: function (data) {
                    const imgWidth = 30;
                    const imgHeight = 30;
                    const title = `Cell Report - ${formData.startDate} - ${formData.endDate}`;
                    const titleFontSize = 16;
                    const titleX = data.settings.margin.left + (imgWidth + 10);
                    const titleY = 22;

                    doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 1, imgWidth, imgHeight);
                    doc.setFontSize(titleFontSize);
                    doc.text(title, titleX, titleY);

                    // Add church title
                    const churchTitle = "ANFGC Halifax";
                    const churchTitleFontSize = 16;
                    const churchTitleX = data.settings.margin.left + (imgWidth + 10);
                    const churchTitleY = 40;

                    doc.setFontSize(churchTitleFontSize);
                    doc.text(churchTitle, churchTitleX, churchTitleY);

                    // Footer
                    var str = "Page " + doc.internal.getNumberOfPages()
                    // Total page number plugin only available in jspdf v1.0+
                    if (typeof doc.putTotalPages === 'function') {
                        str = str + " of " + totalPagesExp;
                    }
                },
                styles: {
                    halign: 'center',
                },
                margin: { top: 65 }
            });

            // Save or download the PDF
            doc.save(`cell_report_${formData.startDate}_${formData.endDate}.pdf`);
        }
    }, [genPDF, report, formData, base64Img, columns, totalPagesExp]);

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
        if (formData != null
            && (formData.startDate == null || formData.startDate === "")) {
            formIsValid = false;
            errors["date"] = "Start Date cannot be empty";
        }
        if (formData != null
            && (formData.endDate == null || formData.endDate === "")) {
            formIsValid = false;
            errors["date"] = "End Date cannot be empty";
        }

        setErrors(errors);
        return formIsValid;
    }

    const handleCreateReport = () => {
        console.log("Generate member");
        getReport(formData);
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFormData(values => ({ ...values, [name]: value ? moment(value).format("YYYY-MM-DD") : "" }));
    }

    const generatePDF = () => {
        console.log("clicked Generate PDF");
        getReport(formData);
        setGenPDF(true);
    };

    const exportToExcel = () => {
        if (!report || report.length === 0) return;

        // Prepare data array with headers
        const excelData = [
            ['No.', 'Date', 'Leader', 'Cell Meeting Day', 'Cell Type', 'Total Regular Members', 'Members Present', 'Total Present']
        ];

        // Map report data to rows
        report.forEach((row, index) => {
            excelData.push([
                index + 1,
                row.date ? moment(row.date, 'YYYY-MM-DD').format('MMM DD, YYYY') : '-',
                row.cell.CellLeader?.name || '',
                row.cell?.meeting_day || '',
                row.cell?.cell_type || '',
                row.cellTotal,
                row.attendanceTotal,
                row.totalAttendance
            ]);
        });

        // Create workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Set column widths
        ws['!cols'] = [
            { wch: 5 },  // No.
            { wch: 14 }, // Date
            { wch: 20 }, // Leader
            { wch: 18 }, // Meeting Day
            { wch: 15 }, // Cell Type
            { wch: 22 }, // Total Members
            { wch: 18 }, // Members Present
            { wch: 15 }  // Total Present
        ];

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Cell Report');

        // Generate filename with date range
        const filename = `cell_report_${formData.startDate}_${formData.endDate}.xlsx`;

        // Save file
        XLSX.writeFile(wb, filename);
    };

    // Handle tab switching with auto-report generation
    const handleTabChange = (tab) => {
        setActiveTab(tab);

        if (tab === 'weekly') {
            const weekRange = getCurrentWeekRange();
            setFormData(weekRange);
            getReport(weekRange);
        } else if (tab === 'monthly') {
            const monthRange = getCurrentMonthRange();
            setFormData(monthRange);
            getReport(monthRange);
        }
    };

    // Handle preset date range buttons
    const handlePresetDateRange = (getRangeFunction, label) => {
        setActiveTab('custom');
        const range = getRangeFunction();
        setFormData(range);
        getReport(range);
    };



    const stats = getReportStats();

    return (
        <div className="min-h-screen bg-gray-100 text-gray-900">
            <main className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {/* Header */}
                <div className="flex flex-row justify-between items-center mb-8">
                    <h1 className="text-3xl font-bold text-gray-900">Cell Reports</h1>
                </div>

                {/* Tab Navigation */}
                <div className="flex flex-row gap-2 mb-4 flex-wrap">
                    <TabButton
                        label="Custom Range"
                        active={activeTab === 'custom'}
                        onClick={() => { setActiveTab('custom'); setFormData({}); }}
                    />
                    <TabButton
                        label="Weekly"
                        active={activeTab === 'weekly'}
                        onClick={() => handleTabChange('weekly')}
                    />
                    <TabButton
                        label="Monthly"
                        active={activeTab === 'monthly'}
                        onClick={() => handleTabChange('monthly')}
                    />
                </div>

                {/* Preset Date Range Buttons */}
                <div className="flex flex-row gap-2 mb-6 flex-wrap">
                    <PresetButton
                        label="1 Week Ago"
                        onClick={() => handlePresetDateRange(getOneWeekAgoRange, '1 Week Ago')}
                    />
                    <PresetButton
                        label="1 Month Ago"
                        onClick={() => handlePresetDateRange(getOneMonthAgoRange, '1 Month Ago')}
                    />
                    <PresetButton
                        label="2 Months Ago"
                        onClick={() => handlePresetDateRange(getTwoMonthsAgoRange, '2 Months Ago')}
                    />
                </div>

                {/* Custom Date Range Form - Only show for custom tab */}
                {activeTab === 'custom' && (
                    <div className="bg-white shadow-lg rounded-lg p-6 mb-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            <div className="flex flex-col">
                                <label htmlFor="startDate" className="block text-sm font-medium leading-6 text-gray-900">Start Date</label>
                                <div className="mt-2">
                                    <input className="px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                        id="startDate"
                                        name="startDate"
                                        type="date"
                                        required
                                        value={formData?.startDate || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <label htmlFor="endDate" className="block text-sm font-medium leading-6 text-gray-900">End Date</label>
                                <div className="mt-2">
                                    <input className="px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                        id="endDate"
                                        name="endDate"
                                        type="date"
                                        required
                                        value={formData?.endDate || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="flex items-end">
                                <Button disabled={!formIsValid} handleSubmit={handleCreateReport} name="Get Report" icon={<DocumentReportIcon className="h-4 w-4" />} />
                            </div>
                        </div>
                    </div>
                )}

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 mb-6">
                    <Button
                        disabled={report?.length === 0}
                        handleSubmit={generatePDF}
                        name="Download PDF"
                        pdf={true}
                        icon={<DocumentDownloadIcon className="h-4 w-4" />}
                    />
                    <Button
                        disabled={report?.length === 0}
                        handleSubmit={exportToExcel}
                        name="Export to Excel"
                        excel={true}
                        icon={<DownloadIcon className="h-4 w-4" />}
                    />
                </div>

                {/* Summary Statistics Cards - Only show when report exists */}
                {report && report.length > 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                        <StatCard
                            title="Total Cells Reporting"
                            value={stats.totalCells}
                            icon={<UserGroupIcon className="h-6 w-6 text-white" />}
                            bgColor="bg-emerald-500"
                        />
                        <StatCard
                            title="Total Members"
                            value={stats.totalMembers}
                            icon={<UsersIcon className="h-6 w-6 text-white" />}
                            bgColor="bg-blue-500"
                        />
                        <StatCard
                            title="Total Present"
                            value={stats.totalPresent}
                            icon={<CheckCircleIcon className="h-6 w-6 text-white" />}
                            bgColor="bg-green-500"
                        />
                        <StatCard
                            title="Attendance %"
                            value={`${stats.averageAttendance}%`}
                            icon={<TrendingUpIcon className="h-6 w-6 text-white" />}
                            bgColor="bg-purple-500"
                        />
                    </div>
                )}

                {/* Report Table */}
                <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                    {report && report.length > 0 ? (
                        <div className="overflow-x-auto">
                            <Table columns={columns} data={report} />
                        </div>
                    ) : (
                        <div className="p-8 text-center text-gray-500">
                            <p className="text-lg">No report data available. Select a date range and click "Get Report" to generate a report.</p>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
}

const TabButton = ({ label, active, onClick }) => {
    return (
        <button
            onClick={onClick}
            className={`px-6 py-3 font-medium rounded-lg transition-colors whitespace-nowrap ${
                active
                    ? 'bg-emerald-500 text-white shadow-md'
                    : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
            }`}
        >
            {label}
        </button>
    );
};

const PresetButton = ({ label, onClick }) => {
    return (
        <button
            onClick={onClick}
            className="px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg border border-blue-200 hover:bg-blue-100 hover:border-blue-300 transition-colors whitespace-nowrap"
        >
            {label}
        </button>
    );
};

const StatCard = ({ title, value, icon, bgColor }) => {
    return (
        <div className="bg-white shadow-lg rounded-lg p-6">
            <div className="flex items-center justify-between">
                <div>
                    <p className="text-gray-600 text-sm font-medium mb-1">{title}</p>
                    <p className="text-3xl font-bold text-gray-900">{value}</p>
                </div>
                <div className={`${bgColor} rounded-full p-3`}>
                    {icon}
                </div>
            </div>
        </div>
    );
};

const Button = ({ disabled, handleSubmit, name, icon, pdf, excel }) => {
    let colorClasses = 'text-emerald-500 border-emerald-500 hover:bg-emerald-500 hover:text-white active:bg-emerald-600';

    if (pdf) {
        colorClasses = 'text-red-500 border-red-500 hover:bg-red-500 hover:text-white active:bg-red-600';
    } else if (excel) {
        colorClasses = 'text-green-600 border-green-600 hover:bg-green-600 hover:text-white active:bg-green-700';
    }

    const baseClasses = 'border font-bold uppercase text-sm px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150 flex flex-row items-center gap-2';
    const disabledClasses = 'disabled:opacity-40 disabled:cursor-not-allowed';

    if (disabled) {
        return (
            <button
                disabled={true}
                className={`${baseClasses} ${disabledClasses} ${colorClasses}`}
                type="button"
            >
                {icon} {name}
            </button>
        );
    }

    return (
        <button
            disabled={false}
            onClick={handleSubmit}
            className={`${baseClasses} ${colorClasses}`}
            type="button"
        >
            {icon} {name}
        </button>
    );
};

AdminReport.propTypes = {
    report: PropTypes.array,
    reportsGetRequested: PropTypes.bool,
    adminReportGetSuccess: PropTypes.bool,
    getReportsRequested: PropTypes.func,
    addReportRequested: PropTypes.func,
};

AdminReport.defaultProps = {
    report: [],
    reportsGetRequested: false,
    adminReportGetSuccess: false,
    reportGetRequested: false,
};

const mapStateToProps = (state) => ({
    report: state.report.reports,
    adminReportGetSuccess: state.report.adminReportGetSuccess,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getReportsRequested,
    getAdminReportRequested,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdminReport);